import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useMonitoringGoods } from './MonitoringContext';
import { ChartContainer } from '@/components/atoms/Chart';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { MOCK_GOODS } from './_mock/mockGoods';

const WEEKDAY_KO = ['일', '월', '화', '수', '목', '금', '토'];
function formatDateWithDay(dateStr: string) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const weekday = WEEKDAY_KO[date.getDay()];
  return `${month}.${day}(${weekday})`;
}

const GoodsDetaiiPriceChart = () => {
  const [searchParams] = useSearchParams();
  const goodsNo = searchParams.get('select');
  const { goods } = useMonitoringGoods();
  const selectedGoods =
    goods.find((item) => String(item.GoodsNo) === String(goodsNo)) ||
    MOCK_GOODS.find((item) => String(item.GoodsNo) === String(goodsNo));

  // 데이터 준비: 최근 9개만, 날짜 오름차순 정렬
  const dailyList =
    selectedGoods?.MonitoringGoodsDetailDailyList?.slice()
      .sort((a, b) => new Date(a.MonitoringDate).getTime() - new Date(b.MonitoringDate).getTime())
      .slice(-9) || [];

  // 차트 데이터
  const chartData = dailyList.map((day) => ({
    date: day.MonitoringDate?.slice(5, 10).replace('-', '.') || '', // MM.DD
    price: day.MonitoringGoodsPrice,
  }));

  // y축 min/max 계산
  const prices = chartData.map((d) => d.price);
  const yMin = Math.min(...prices);
  const yMax = Math.max(...prices);

  return (
    <div className="mx-[60px]  grid gap-y-[12px] rounded-[16px]  bg-white p-4">
      <div className="scrollbar flex max-h-[410px] max-w-[1680px] flex-col overflow-x-auto">
        <div className="mb-2 text-gr-900 Body1S16">가격 변동 추적</div>
        <ChartContainer config={{}} className="h-[274px] min-h-[188px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={chartData} margin={{ top: 22, right: 10, bottom: 0, left: 0 }}>
              <XAxis
                dataKey="date"
                tickLine={false}
                axisLine={false}
                tickMargin={10}
                interval={'preserveStartEnd'}
                tick={{
                  fontSize: 12,
                  fontWeight: 500,
                  fill: '#53555E',
                  textAnchor: 'middle',
                }}
                tickFormatter={formatDateWithDay}
              />
              <YAxis
                dataKey="price"
                type="number"
                domain={[yMin === yMax ? yMin - 100 : yMin, yMax === yMin ? yMax + 100 : yMax]}
                tickCount={10}
                allowDecimals={false}
                tick={{
                  fontSize: 10,
                  fontWeight: 500,
                  fill: '#53555E',
                }}
              />
              <Tooltip
                formatter={(value) => `${value?.toLocaleString()}원`}
                // labelFormatter={(label) => ` ${label}`}
                contentStyle={{ background: 'rgba(255,255,255,0.95)', borderRadius: 8 }}
              />
              <defs>
                <linearGradient id="fillPrice" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#04A5E21A" stopOpacity={1} />
                  <stop offset="95%" stopColor="#04A5E21A" stopOpacity={0.1} />
                </linearGradient>
              </defs>
              <Area
                dataKey="price"
                type="monotone"
                fill="url(#fillPrice)"
                fillOpacity={0.4}
                stroke="#4B93FF"
                strokeWidth={2}
                dot={{ stroke: '#4B93FF', strokeWidth: 2, r: 4, fill: '#fff' }}
                isAnimationActive={true}
              />
            </AreaChart>
          </ResponsiveContainer>
        </ChartContainer>
      </div>
    </div>
  );
};

export default GoodsDetaiiPriceChart;
